import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { createBrowserHistory } from "history";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "rsuite/dist/rsuite.min.css";
import "react-toastify/dist/ReactToastify.css";

import LoginPage from "./pages/Login/LoginPage";
import RecuperarPassword from "./pages/Login/RecuperarPassword/RecuperarPassword";
import HomeScreen from "./pages/Home/HomeScreen";
import VentasPage from "./pages/Ventas/VentasPage";
import { ToastContainer } from "react-toastify";
import ProductosPage from "./pages/Productos/ProductosPage";
import AfiliacionesPage from "./pages/afiliaciones/AfiliacionesPage";
import UsuariosPage from "./pages/Usuarios/UsuariosPage";
import SolicitudesPage from "./pages/Solicitudes/SolicitudPage";
import LocacionesPage from "./pages/locaciones/LocacionesPage";
import NacionalidadesPage from "./pages/Nacionlidades/NacionalidadesPage";
import FacturacionPage from "./pages/facturacion/FacturacionPage";


export const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL,
});

// ===== helpers permisos =====
const getUser = () => {
  try {
    const raw = localStorage.getItem("sharem");
    return raw ? JSON.parse(raw) : null; 
  } catch (e) {
    localStorage.removeItem("sharem");
    return null;
  }
};

const getRole = () => {
  const u = getUser();
  const role = String(u?.role || "").trim();
  return role || "Agencia";
};

const firstAllowedRoute = (role) => {
  const r = String(role || "").toLowerCase();
  if (r === "administrador") return "/ventas";
  if (r === "contador") return "/ventas";
  return "/solicitudes"; // Agencia
};

const isAllowed = (pathname, role) => {
  const r = String(role || "").toLowerCase();
  const path = String(pathname || "");

  if (r === "administrador") return true;

  if (r === "contador") {
    if (path.startsWith("/ventas")) return true;
    if (path.startsWith("/solicitudes")) return true;
    if (path.startsWith("/facturacion")) return true;
    if (path.startsWith("/productos")) return true;
    if (path.startsWith("/afiliaciones")) return true;
    if (path.startsWith("/locaciones")) return true;
    if (path.startsWith("/nacionalidades")) return true;
    if (path.startsWith("/user")) return false;
    return false;
  }

  if (path.startsWith("/solicitudes")) return true;
  return false;
};

// ===== Route protegido =====
const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      const user = getUser();
      if (!user) return <Redirect to="/" />;

      const role = getRole();
      const ok = isAllowed(props.location.pathname, role);

      if (!ok) {
        return <Redirect to={firstAllowedRoute(role)} />;
      }

      return <Component {...props} />;
    }}
  />
);

function App() {
  return (
    <>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <Switch>
          {/* Public */}
          <Route path="/recuperar" component={RecuperarPassword} />
          <Route exact path="/" component={LoginPage} />

          {/* Si alguien entra a /home, lo mandamos a su home real */}
          <Route
            path="/home"
            render={() => {
              const user = getUser();
              if (!user) return <Redirect to="/" />;
              const role = getRole();
              return <Redirect to={firstAllowedRoute(role)} />;
            }}
          />

          {/* Private (protegidas por rol) */}
          <PrivateRoute path="/ventas" component={VentasPage} />
          <PrivateRoute path="/productos" component={ProductosPage} />
          <PrivateRoute path="/afiliaciones" component={AfiliacionesPage} />
          <PrivateRoute path="/user" component={UsuariosPage} />
          <PrivateRoute path="/solicitudes" component={SolicitudesPage} />
          <PrivateRoute path="/locaciones" component={LocacionesPage} />
          <PrivateRoute path="/facturacion" component={FacturacionPage} />

          <PrivateRoute path="/nacionalidades" component={NacionalidadesPage} />

          {/* fallback */}
          <Route
            render={() => {
              const user = getUser();
              if (!user) return <Redirect to="/" />;
              const role = getRole();
              return <Redirect to={firstAllowedRoute(role)} />;
            }}
          />
        </Switch>
      </BrowserRouter>

      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

export default App;